module.exports = __webpack_public_path__ + "static/pca-9a527932f700bdc760fdb90e2ec00f82.jpeg";